import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMobileSdkTestFilterOptions } from 'src/apps/mobile-sdk/services/MobileSdkDashboardService';
import { TMobileSdkTestFilterOptions } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { MOBILE_SDK_TEST_FILTER_OPTIONS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMobileSdkTestFilterOptionsQuery = (
	testId: string
): UseQueryResult<TMobileSdkTestFilterOptions> => {
	const testFilterOptionsQuery = useQuery([MOBILE_SDK_TEST_FILTER_OPTIONS, testId], () =>
		getMobileSdkTestFilterOptions(testId)
	);

	return testFilterOptionsQuery;
};
